import React, {useEffect, useRef, useState} from 'react';
import { connect } from 'react-redux';
import { useCookies } from 'react-cookie';
import {cookies_string} from '../config.js';
import { Login } from '../actions/actions.js';
import { useNavigate, useLocation, useSearchParams } from 'react-router-dom';
import '../App.css'
import './news.css'
import '../components/home/home.css'

//
import Mask from './components/MaskAnimation.js';
import Carousell from '../components/caro.js';
import Footer from './components/Footer.js';
import InViewComponent from './components/InView.js';
import PageSelector from '../components/PageSelector.js'
//
import LeftSvg from '../svgs/facility/leftSvg.js'
import RightSvg from '../svgs/facility/rightSvg.js'
//
import {getNewsTag, getNewsDetail} from '../services/news.js'
import CONTENT from '../contents/new.js'
import HOMECONTENT from '../contents/home.js'

const all = {
    label: 'all',
    label_tc:'全部',
    label_sc:'全部',
}
function Component({}) {
    const navigate = useNavigate();
    const location = useLocation();
    const [ __, _, removeCookie] = useCookies([`${cookies_string}_cred`,`${cookies_string}_token`]);
    const [searchParams, setSearchParams] = useSearchParams();
    const lang = searchParams.get('lang')
    const type =  searchParams.get('type')
    //
    const ref1 = useRef()
    const ref2 = useRef()
    const cut1 = useRef()
    
    const [selectedFilter, setSelectedFilter] = useState(null)
    //
    const [total, setTotal] = useState(1);
    const page =  parseInt(searchParams.get('page'))||1;
    const LIMIT = 16
    const totalPage = Math.ceil(total / LIMIT)
    //
    const [tags, setTags] = useState([])
    const [news, setNews] = useState([])
    useEffect(() => {
        const getData = async () => {
            if(!tags.length){
                const tagRes = await getNewsTag()
                if(tagRes.errno) return;
                tagRes.result.unshift(all)
                setTags(tagRes.result)
            }
            //articles
            const filter = {
                status:'PUBLISHED'
            }
            const options = {
                limit:LIMIT,
                skip:(page-1) * LIMIT,
                sort:{createDate: 1}
            }
            if(type !== null) {
                filter.genere = {$in:[tags.filter(t => t.label === type)[0]?._id]}
            }
            const newsRes = await getNewsDetail(filter, options)
            if(newsRes.errno)return;
            setTotal(Math.max(newsRes.count, 1))
            setNews(newsRes.result)

        }
        getData()
    },[type])

    const handleSetParams = (key, value, isRemove=false) => {
        searchParams.delete(key)
        if(!isRemove)searchParams.append(key, value)
        setSearchParams(searchParams)
    }
    const handleSelectPage=(p)=> async ()=>{
        if(p > totalPage || p < 1) return;
        handleSetParams('page', p)
    }

    const handleSelectedType = (tag) => {
        if(tag === 'all' || tag === type) return handleSetParams('type', tag, true)
        handleSetParams('type', tag)
    }
    const tagLangKey = () => {
        if(lang === 'tc') return 'label_tc'
        if(lang === 'sc') return 'label_sc'
        if(lang === 'en') return 'label'
    }
    const langKeySelector = () => {
        if(lang === 'tc') return 'ch'
        if(lang === 'sc') return 'sc'
        if(lang === 'en') return 'en'
    }
    return(
        <div className='bg-white w-full flex flex-col'>
            <div className='w-full flex flex-col'>
                {/* sec1 */}
                <div className='w-full h-[50vh] addnavpadding relative'>
                    <div className='absolute bottom-5 left-5 vert-text text-white text-[8px] font-[500] m-show-d-hidden'>No. 21 Whitfield Road Causeway Bay Hong Kong Island Hong Kong</div>
                    <img src='./images/news/banner.png' className='w-full h-full' style={{objectFit:'cover'}}></img>
                </div>
                <div className='relative x-padding w-full min-h-[100vh] flex flex-col items-center justify-start'>
                    <div id='news and topics' className='absolute top-[-10vh]'></div>
                    <img src='./images/bg_texture.jpg' className='absolute w-full h-full select-none' style={{objectFit:'cover'}}></img>
                    <InViewComponent reffing={ref1} active='title_text_active'delay={2000}/>
                    <div ref={ref1} className='title_text relative text-d-35 playfair-display my-[79px]'>{CONTENT.new_0[lang]}</div>
                    <div  ref={cut1} className='cut_down w-[1px] h-[70px] absolute top-0 left-50 bg-black'></div>
                    <InViewComponent reffing={cut1} active='cut_down_active'delay={2000}/>
                    <div className='relative w-[90%] max-w-[1300px] flex flex-col'>
                        <div ref={ref2} className='title_text w-full flex flex-row-col items-center-start justify-start mb-[48px]'>
                            {tags.map((obj, i ) => <div className=''>
                                <div key={obj._id} className='text-d-12 cursor-pointer inline-block hover:font-bold py-[5px] select-none' style={{fontWeight:obj.label === type ? 'bold' : 400}} onClick={() => handleSelectedType(obj.label)}>{obj[tagLangKey()]}</div> 
                                {i !== tags.length - 1 &&<span className='px-[12px] text-[12px] d-show-m-hidden'>/</span>}
                            </div>)} 
                        </div>
                        <InViewComponent reffing={ref2} active='title_text_active' delay={3000}/>
                        <div className='flex flex-row flex-wrap items-between justify-evenly mb-[128px]' style={{rowGap:48}}>
                            {news.map((obj, i) => (
                                <div className='relative flex flex-col items-center justify-start max-w-[294px] cursor-pointer' onClick={() => navigate(`/news/${obj._id}?lang=${lang}`, { state: obj._id })}>
                                    <div className='flex flex-col items-center justify-start'>
                                        <div className='relative overflow-hidden select-none' style={{aspectRatio:294/191}}>
                                            {/* overlay */}
                                            <div className='absolute w-full h-full appear-cover-2 flex flex-col items-center justify-center' style={{zIndex:2}}>
                                                <div className='flex flex-col items-center justify-center w-[70%] h-[90%]' style={{gap:24}}>
                                                    <div className='w-[118px] h-[118px] relative topleft-cutto-bottomright'>
                                                    <div className='w-full h-[1px] absolute top-[50%] bg-[#0FBAB5]'></div>
                                                    <div className='w-[1px] h-full absolute left-[50%] bg-[#0FBAB5]'></div>
                                                    </div>
                                                </div>
                                            </div>
                                            <img className='relative w-full h-full' src={obj.previewImage} style={{objectFit:'cover'}}></img>
                                        </div>
                                        <div className='text-d-10 text-[#0FBAB5] select-none'>{obj.publishDate}</div>
                                        <div className='text-d-12 text-center'>{obj[`name_${langKeySelector()}`]}</div>
                                    </div>
                                </div>
                            ))}
                            {!news?.length && <div className='min-h-[300px] flex flex-row items-center justify-center'>{HOMECONTENT.noNews[lang]}</div>}
                        </div>
                        <PageSelector page={page} hideTotal={true} total={total} totalPage={totalPage} handleSelectPage={handleSelectPage} />
                    </div>
                </div>
                {/* sec2 */}
            </div>
            <Footer />
            <Mask />
        </div>
    )
}
export default connect((store)=>{
    return{
      token:store.tokenReducer,
    }
  })(Component)